import type { CSSProperties, HTMLAttributes, ReactNode } from "react";
import { scaledPx } from "@/styles/scaledFont";

export interface FineProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

/* 05-SHARED.md §"Общие атомы": `400 10px/15px JetBrains Mono`,
 * letter-spacing .04em, uppercase, `--d-fg-4`. */
const BASE: CSSProperties = {
  fontFamily: "var(--font-mono)",
  fontWeight: 400,
  fontSize: scaledPx(10),
  lineHeight: scaledPx(15),
  letterSpacing: ".04em",
  textTransform: "uppercase",
  color: "var(--d-fg-4)",
};

/**
 * The disclaimer line — one notch quieter and looser than `Kicker`.
 *
 * Ported from `Fine` in
 * `docs/design/handoff/design/templates/onboarding/onboarding-screen.jsx`.
 */
export function Fine({
  className,
  style,
  children,
  ...rest
}: FineProps): JSX.Element {
  return (
    <span className={className} style={{ ...BASE, ...style }} {...rest}>
      {children}
    </span>
  );
}

export default Fine;
